import { Box, Flex, Table, Tbody, Td, Text, Tr } from '@chakra-ui/react';

import type { SelectionList } from '@revelio/iso-utility';

import type { DataBuilderCustomColumn } from '../../data-builder.store';
import type { FieldGranularityMap, FieldLabelMap } from './DatasetSummaryCard';
import { ConditionDetail } from './FiltersSummary';
import { SummaryPopover, SummaryTrigger } from './SummaryPrimitives';

export const CustomColumnsSummary = ({
  customColumns,
  selectionLists,
  fieldLabelMap,
  fieldGranularityMap,
}: {
  customColumns: DataBuilderCustomColumn[];
  selectionLists?: SelectionList[];
  fieldLabelMap?: FieldLabelMap;
  fieldGranularityMap?: FieldGranularityMap;
}) => {
  if (customColumns.length === 0) {
    return <>None</>;
  }

  return (
    <>
      {customColumns.map((customColumn, index) => {
        const isLast = index === customColumns.length - 1;

        return (
          <SummaryPopover
            key={customColumn.id}
            trigger={
              <Box as="span" mr="1">
                <SummaryTrigger text={customColumn.name} />
                {!isLast && ','}
              </Box>
            }
          >
            <Table size="sm" variant="unstyled" w="max-content">
              <Tbody>
                {customColumn.steps.map((step, stepIndex) => {
                  if (step.case !== null) {
                    const stepCase = step.case;

                    return (
                      <Tr key={`${customColumn.id}-${stepIndex}`}>
                        <Td px="0">
                          <Text mr="2" textColor="pink.700">
                            {stepIndex === 0 ? 'If' : 'Else if'}
                          </Text>
                        </Td>
                        <Td px="0">
                          <Flex alignItems="center" gap="1">
                            <Box
                              borderY="0"
                              borderX="1px"
                              borderRadius="15px"
                              p="1"
                              borderColor="pink.700"
                            >
                              {stepCase.conditions.map(
                                (condition, conditionIndex) => (
                                  <ConditionDetail
                                    key={`${customColumn.id}-${stepIndex}-${conditionIndex}`}
                                    condition={condition}
                                    binary={stepCase.binary}
                                    showBinary={
                                      conditionIndex !==
                                      stepCase.conditions.length - 1
                                    }
                                    selectionLists={selectionLists}
                                    fieldLabelMap={fieldLabelMap}
                                    fieldGranularityMap={fieldGranularityMap}
                                  />
                                )
                              )}
                            </Box>
                            <Text ml="1" textColor="pink.700">
                              Then
                            </Text>
                          </Flex>
                        </Td>
                        <Td px="0">
                          <Text ml="2" as="b" textColor="green.500">
                            &quot;{step.then}&quot;
                          </Text>
                        </Td>
                      </Tr>
                    );
                  }

                  return (
                    <Tr key={`${customColumn.id}-${stepIndex}`}>
                      <Td px="0" textColor="pink.700">
                        Else
                      </Td>
                      <Td />
                      <Td as="b" textColor="green.500">
                        &quot;{step.then}&quot;
                      </Td>
                    </Tr>
                  );
                })}
              </Tbody>
            </Table>
          </SummaryPopover>
        );
      })}
    </>
  );
};
